// ==================== PDF GENERATION ====================
function generatePDF() {
    // Check minimum components
    const selectedComponents = Object.values(selectedProducts).filter(product => product !== null).length;
    if (selectedComponents < 4) {
        showPDFMessage('Please select at least 4 components before downloading PDF');
        return;
    }

    // Double-check: ensure no compatibility issues and user is from India
    if (!csCalcIsIndiaUser) {
        showPDFMessage('PDF export is available to Indian users only');
        return;
    }
    
    // Additional protection: check if buttons are disabled
    const pdfBtn = document.querySelector('.cs-calc-pdf-btn');
    if (pdfBtn && pdfBtn.disabled) {
        showPDFMessage('Please resolve compatibility issues first');
        return;
    }

    // Use HTML2Canvas method for BOTH mobile and desktop
    generatePDFWithHTML2Canvas();
}

function showPDFMessage(message) {
    const pdfMessage = document.getElementById('pdf-message');
    if (pdfMessage) {
        pdfMessage.textContent = message;
        pdfMessage.style.display = 'block';
        setTimeout(() => {
            pdfMessage.style.display = 'none';
        }, 5000);
    } else {
        alert(message);
    }
}

// ==================== SIMPLIFIED DESKTOP PDF WITH HTML2CANVAS ====================
function generatePDFWithHTML2Canvas() {
    // Show loading state on PDF button
    const pdfButton = document.querySelector('.cs-calc-pdf-btn');
    if (!pdfButton) return;
    
    const originalText = pdfButton.innerHTML;
    pdfButton.innerHTML = '<div class="cs-calc-button-loading">Generating PDF...</div>';
    pdfButton.disabled = true;

    const pdfMessage = document.getElementById('pdf-message');
    if (pdfMessage) pdfMessage.style.display = 'none';

    // Generate the HTML content
    const cleanHTML = createCompletePDFContent();
    
    // Create an IFRAME instead of a div - this isolates the content completely
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.left = '-9999px';
    iframe.style.top = '0';
    iframe.style.width = '800px';
    iframe.style.height = '1200px';
    iframe.style.border = 'none';
    iframe.style.visibility = 'hidden';
    
    document.body.appendChild(iframe);
    
    // Write the clean HTML to iframe
    iframe.contentDocument.open();
    iframe.contentDocument.write(cleanHTML);
    iframe.contentDocument.close();
    
    // Wait for iframe to load
    iframe.onload = function() {
        setTimeout(() => {
            const iframeBody = iframe.contentDocument.body;
            
            // Use html2canvas on the iframe body
            html2canvas(iframeBody, {
                scale: 2,
                useCORS: true,
                logging: false,
                backgroundColor: '#ffffff',
                allowTaint: true
            }).then(canvas => {
                // Remove iframe
                if (document.body.contains(iframe)) {
                    document.body.removeChild(iframe);
                }

                // Create PDF
                const imgData = canvas.toDataURL('image/jpeg');
                const pxToMm = 0.264583;
                const contentWidth = canvas.width * pxToMm;
                const contentHeight = canvas.height * pxToMm;
                const fixedWidth = 210;
                const scale = fixedWidth / contentWidth;
                const scaledHeight = contentHeight * scale;

                const pdf = new jspdf.jsPDF({
                    orientation: scaledHeight > fixedWidth ? 'portrait' : 'landscape',
                    unit: 'mm',
                    format: [fixedWidth, scaledHeight]
                });

                pdf.addImage(imgData, 'JPEG', 0, 0, fixedWidth, scaledHeight);
                pdf.save(`PCBuildz_Quotation_${new Date().toISOString().split('T')[0]}.pdf`);

                // SHOW SUCCESS MESSAGE
            if (pdfMessage) {
    pdfMessage.textContent = 'PDF downloaded successfully!';
    pdfMessage.className = 'cs-calc-message success';
    pdfMessage.style.display = 'block';
    setTimeout(() => {
        pdfMessage.style.display = 'none';
    }, 10000);
}

                pdfButton.innerHTML = originalText;
                pdfButton.disabled = false;
                
            }).catch(error => {
                console.error('PDF Generation Error:', error);
                
                // Remove iframe on error
                if (document.body.contains(iframe)) {
                    document.body.removeChild(iframe);
                }

                // Error message
                const pdfMessage = document.getElementById('pdf-message');
                if (pdfMessage) {
                    pdfMessage.textContent = 'Failed to generate PDF. Please try again.';
                    pdfMessage.style.display = 'block';
                    setTimeout(() => {
                        pdfMessage.style.display = 'none';
                    }, 3000);
                }

                pdfButton.innerHTML = originalText;
                pdfButton.disabled = false;
            });
        }, 1000); // Give time for images to load
    };
}

// ==================== REMOVED FUNCTIONS ====================
// Remove the following functions completely as they're no longer needed:
// - generatePDFWithAPDF()
// - calculateContentHeight() 
// - sendJsonpRequest() function for aPDF.io

// ==================== UPDATED aPDF CONFIG SECTION ====================
// You can remove or comment out these lines since they're no longer used:
// const APDF_API_URL = 'https://apdf.io/api/pdf/file/create';
// const APDF_MOBILE_TOKEN = 'zPSuNC00CsUKfVhWoOnZhha2bMAxacMMTH11ud3W7146b3e1';
// const APDF_DESKTOP_TOKEN = 'CTO9dOu6Qgey8mAiSDd807VpqYhIEXuokDsl6LVyf0cf1958';

async function calculateContentHeight(htmlContent) {
    return new Promise((resolve) => {
        const tempDiv = document.createElement('div');
        tempDiv.style.cssText = `
            position: fixed;
            left: -9999px;
            top: 0;
            width: 800px;
            padding: 30px;
            background: white;
            font-family: Arial, sans-serif;
            visibility: hidden;
        `;
        tempDiv.innerHTML = htmlContent;
        document.body.appendChild(tempDiv);

        const images = tempDiv.getElementsByTagName('img');
        let imagesLoaded = 0;
        const totalImages = images.length;

        if (totalImages === 0) {
            const height = tempDiv.scrollHeight;
            // FIX: Check if element still exists before removing
            if (tempDiv.parentNode) {
                document.body.removeChild(tempDiv);
            }
            resolve(height);
            return;
        }

        const checkAllLoaded = () => {
            imagesLoaded++;
            if (imagesLoaded === totalImages) {
                setTimeout(() => {
                    const height = tempDiv.scrollHeight;
                    // FIX: Check if element still exists before removing
                    if (tempDiv.parentNode) {
                        document.body.removeChild(tempDiv);
                    }
                    resolve(height);
                }, 100);
            }
        };

        Array.from(images).forEach(img => {
            if (img.complete) checkAllLoaded();
            else {
                img.onload = checkAllLoaded;
                img.onerror = checkAllLoaded;
            }
        });

        setTimeout(() => {
            const height = tempDiv.scrollHeight;
            // FIX: Check if element still exists before removing
            if (tempDiv.parentNode) {
                document.body.removeChild(tempDiv);
            }
            resolve(height);
        }, 3000);
    });
}

function createCompletePDFContent() {
    const totalProductPrice = calculateTotalProductPrice();
    const gstAmount = calculateGST();
    const totalPrice = calculateTotalPrice();
    const currentDateTime = getFormattedDateTime();
    
    const selectedCase = selectedProducts['Case'];
    const selectedGPU = selectedProducts['GPU'];
    
    // Check compatibility status for PDF
    const warningsContainer = document.getElementById('compatibility-warnings');
    const hasWarnings = warningsContainer && 
                       warningsContainer.style.display === 'block' && 
                       warningsContainer.classList.contains('has-warnings');
    const compatibilityStatus = hasWarnings ? 'Compatibility Issues Detected' : 'All Selected Components are compatible';
    const statusColor = hasWarnings ? '#dc2626' : '#10b981';
    const statusIcon = hasWarnings ? '⚠️' : '✅';
    
    // Build summary rows - show in correct order
    let buildSummaryHTML = '';
    
    // Define the correct order for PDF display
    const pdfCategoryOrder = [
        'CPU', 'Motherboard', 'RAM', 'Storage (SSD)', 'Storage (HDD)', 
        'GPU', 'Cooling', 'PSU', 'Case', 'Case Fan', 
        'Monitor', 'Keyboard', 'Mouse', 'Headset', 'Accessories'
    ];
    
    // Filter and sort products according to the defined order
    const selectedProductsArray = pdfCategoryOrder
        .map(category => [category, selectedProducts[category]])
        .filter(([category, product]) => product !== null);
    
    selectedProductsArray.forEach(([category, product], index) => {
        const isLastItem = index === selectedProductsArray.length - 1;
        const quantity = productQuantities[category] || 1;
        const totalPrice = product.price * quantity;
        const convertedImageUrl = convertGoogleDriveUrl(product.imageUrl);
        const borderStyle = isLastItem ? 'none' : '1px solid #969799';
        const paddingStyle = isLastItem ? 'padding: 12px 0 0 0;' : 'padding: 12px 0;';
        
        // Map category to display names for PDF
        const categoryDisplayNames = {
            'CPU': 'Processor',
            'Motherboard': 'Motherboard',
            'RAM': 'RAM',
            'Storage (SSD)': 'Storage (SSD)',
            'Storage (HDD)': 'Storage (HDD)',
            'GPU': 'GPU',
            'Cooling': 'Cooling',
            'PSU': 'PSU',
            'Case': 'Case',
            'Case Fan': 'Case Fan',
            'Monitor': 'Monitor',
            'Keyboard': 'Keyboard',
            'Mouse': 'Mouse',
            'Headset': 'Headset',
            'Accessories': 'Accessories'
        };
        
        const displayCategory = categoryDisplayNames[category] || category;
        
        // Format product name with brand prefix for PDF
        let displayName = product.name;
        const brand = product.brand || '';
        
        if (brand && !product.name.toLowerCase().includes(brand.toLowerCase())) {
            // Add brand only if it's not already in the product name
            displayName = `${brand} ${product.name}`;
        }
        
        buildSummaryHTML += `
            <div style="display: grid; grid-template-columns: 1fr auto; align-items: start; ${paddingStyle} border-bottom: ${borderStyle}; gap: 16px; min-height: 80px; font-family: Arial, sans-serif;">
                <!-- Left Column: Content -->
                <div style="display: flex; flex-direction: column; gap: 6px; min-width: 0; grid-column: 1;">
                    <!-- Row 1: Category and Quantity -->
                    <div style="color: #0f1724; font-weight: 800; font-size: 15px; display: flex; align-items: center; justify-content: space-between; margin-bottom: 0; max-width: 350px;">
                        ${displayCategory}
                        <span style="font-weight: 700; color: #374151; font-size: 14px; white-space: nowrap; margin-left: 12px;">Qty: ${quantity}</span>
                    </div>
                    <!-- Row 2: Product Name with Brand -->
                    <div style="font-weight: 600; font-size: 14px; color: #374151; line-height: 1.3; word-wrap: break-word; margin: 2px 0;">
                        ${displayName}
                    </div>
                    <!-- Row 3: Price -->
                    <div style="color: #10b981; font-weight: 800; font-size: 16px; margin-top: 0;">
                        ₹${totalPrice.toLocaleString()}
                    </div>
                </div>
                
                <!-- Right Column: Product Image -->
                <div style="display: flex; align-items: center; justify-content: center; height: 100%; grid-column: 2;">
                    ${convertedImageUrl ? `
                        <img src="${convertedImageUrl}" alt="${displayName}" 
                             crossorigin="anonymous"
                             style="width: 75px; height: 75px; border-radius: 8px; padding: 4px; object-fit: cover; border: 2px solid #a2a4a6; flex-shrink: 0; justify-self: end; align-self: center;">
                    ` : ''}
                </div>
            </div>
        `;
    });
    
    // Total Price Section
    const totalPriceHTML = `
        <div style="margin-top: 25px; padding-top: 20px; border-top: 2px solid #10b981; font-family: Arial, sans-serif;">
            <div style="display: flex; justify-content: space-between; margin-bottom: 10px; font-size: 15px;">
                <strong>Total Product Price:</strong>
                <strong>₹${totalProductPrice.toLocaleString()}</strong>
            </div>
            <div style="display: flex; justify-content: space-between; margin-bottom: 10px; font-size: 15px;">
                <strong>Total GST (18%):</strong>
                <strong>₹${gstAmount.toLocaleString()}</strong>
            </div>
            <div style="display: flex; justify-content: space-between; font-size: 18px; color: #10b981; font-weight: 800; padding-top: 10px; border-top: 1px solid #969799;">
                <strong>Total Price:</strong>
                <strong>₹${totalPrice.toLocaleString()}</strong>
            </div>
        </div>
    `;
    
    // Case and Compatibility Section
    let caseCompatibilitySectionHTML = '';
    
    // SCENARIO 1 & 2: Case is selected (with or without GPU)
    if (selectedCase && selectedCase.imageUrl) {
        let directImageUrl = convertGoogleDriveUrl(selectedCase.imageUrl);
        
        // Calculate recommended PSU wattage if GPU is selected
        let psuWattageHTML = '';
        if (selectedGPU && selectedGPU.wattage) {
            psuWattageHTML = `
                <div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 8px 12px; border-radius: 6px; margin-top: 10px; text-align: center; font-family: Arial, sans-serif;">
                    <div style="font-weight: 600; font-size: 12px; margin-bottom: 2px;">Recommended PSU</div>
                    <div style="font-weight: 800; font-size: 16px;">${selectedGPU.wattage}W</div>
                </div>
            `;
        }
        
        // 3-column layout with vertical centering
        caseCompatibilitySectionHTML = `
            <div style="margin: 40px 0; padding: 25px; background: #e8e9eb; border-radius: 8px; border-left: 4px solid #6b10b5; font-family: Arial, sans-serif;">
                <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 30px; align-items: center; min-height: 180px;">
                    <!-- Left Column: Case Info -->
                    <div style="display: flex; flex-direction: column; justify-content: center; height: 100%;">
                        <div style="font-size: 18px; font-weight: bold; color: #0f2937; margin-bottom: 10px;">PC Build Preview</div>
                        <div style="font-size: 16px; font-weight: 600; color: #374151; margin-bottom: 15px;">Selected Case: ${selectedCase.name}</div>
                        ${psuWattageHTML}
                    </div>
                    
                    <!-- Middle Column: Case Image -->
                    <div style="text-align: center; display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%;">
                        <img src="${directImageUrl}" alt="${selectedCase.name}" 
                             crossorigin="anonymous" 
                             style="max-width: 200px; max-height: 140px; border-radius: 8px; border: 2px solid #a2a4a6; padding: 8px; object-fit: contain;">
                        <div style="color: red; font-size: 12px; margin-top: 8px; font-style: italic;">
                            This image is for reference only
                        </div>
                    </div>
                    
                    <!-- Right Column: Compatibility Status -->
                    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; text-align: center;">
                        <div style="font-size: 32px; margin-bottom: 10px; color: ${statusColor};">${statusIcon}</div>
                        <div style="background: ${statusColor}; color: white; padding: 12px 20px; border-radius: 8px; font-weight: 800; font-size: 16px; line-height: 1.4; text-align: center;">
                            ${compatibilityStatus}
                        </div>
                    </div>
                </div>
            </div>
        `;
    } 
    // SCENARIO 3: No case selected, but GPU is selected
    else if (selectedGPU && selectedGPU.wattage) {
        caseCompatibilitySectionHTML = `
            <div style="margin: 40px 0; padding: 25px; background: #e8e9eb; border-radius: 8px; border-left: 4px solid #6b10b5; font-family: Arial, sans-serif;">
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 30px; align-items: center; min-height: 120px;">
                    <!-- Left Column: PSU Recommendation -->
                    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; text-align: center;">
                        <div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 15px 20px; border-radius: 8px; width: 100%; max-width: 250px;">
                            <div style="font-weight: 700; font-size: 16px; margin-bottom: 6px;">Recommended PSU Wattage</div>
                            <div style="font-weight: 900; font-size: 24px;">${selectedGPU.wattage}W</div>
                        </div>
                    </div>
                    
                    <!-- Right Column: Compatibility Status (NO big tick mark) -->
                    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; text-align: center;">
                        <div style="background: ${statusColor}; color: white; padding: 21px 25px; border-radius: 8px; font-weight: 800; font-size: 16px; line-height: 1.4; text-align: center; width: 100%; max-width: 250px;">
                            ${compatibilityStatus}
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
    // SCENARIO 4: Neither case nor GPU selected
    else {
        caseCompatibilitySectionHTML = `
            <div style="margin: 40px 0; padding: 30px; background: #e8e9eb; border-radius: 8px; border-left: 4px solid #6b10b5; font-family: Arial, sans-serif;">
                <div style="text-align: center;">
                    <!-- NO big tick mark, just the status box -->
                    <div style="background: ${statusColor}; color: white; padding: 15px 30px; border-radius: 8px; font-weight: 800; font-size: 18px; display: inline-block;">
                        ${compatibilityStatus}
                    </div>
                </div>
            </div>
        `;
    }
    
    return `
        <div style="max-width: 800px; margin: 0 auto; padding: 30px; background: white; font-family: Arial, sans-serif;">
            <div style="text-align: center; margin-bottom: 30px; border-bottom: 3px solid #10b981; padding-bottom: 20px;">
                <img src="https://pcbuildz.in/cdn/shop/files/PCBuildz-PC-Builder-PDF-Header-Image.webp?v=1764346701" 
                     alt="PCBuildz Header" 
                     crossorigin="anonymous"
                     style="width: 100%; max-height: auto; object-fit: cover; margin-bottom: 10px; border-radius: 4px;">
                <h1 style="color: #0f2937; margin: 0 0 8px 0; font-size: 28px; font-weight: 800; font-family: Arial, sans-serif;">Custom PC Build Quotation</h1>
                <p style="color: #6b7280; margin: 0; font-size: 14px; font-family: Arial, sans-serif;">Generated on: ${currentDateTime}</p>
            </div>
            
            <div style="text-align: justify; line-height: 1.6; margin-bottom: 30px; font-size: 14px; color: #374151; font-family: Arial, sans-serif;">
                <p style="margin-bottom: 12px;"><strong>Dear Customer,</strong></p>
                <p style="margin-bottom: 12px; text-align: justify;">Thank you for using the <strong style="color: #1b76e8;">PCBuildz</strong> Instant Custom PC Build Price Calculator & Compatibility Checker!</p>
                <p style="margin-bottom: 12px; text-align: justify;"><strong>"PCBuildz is a brand owned and operated by NEXTGEN IT SOLUTIONS"</strong></p>
                <p style="margin-bottom: 12px; text-align: justify;"><strong>"This is system generated comprehensive summary and quotation for the components you selected."</strong></p>
                <p style="margin-bottom: 12px; text-align: justify;"><strong>Please note:</strong> <strong style="color: #dc2626;">The component prices listed below are not final, and are only valid for 1 day, due to frequent fluctuations in the international market and stock availability.</strong> We highly recommend confirming your order promptly to lock in these prices.</p>
                <p style="margin-bottom: 12px; text-align: justify;">If you are not satisfied with the overall build price or the price of a single component or have any other requirements, you may contact us directly for personalized <strong>1 on 1</strong> assistance:</p>
                <ul style="margin: 15px 0; padding-left: 20px; font-family: Arial, sans-serif; text-align: justify;">
                    <li style="margin-bottom: 8px; text-align: justify;"><strong>Email:</strong> <strong style="color: #1b76e8;">sales@pcbuildz.in</strong></li>
                    <li style="margin-bottom: 8px; text-align: justify;"><strong>WhatsApp:</strong> <strong style="color: #1b76e8;">+919510951019</strong></li>
                    <li style="margin-bottom: 8px; text-align: justify;"><strong>Phone:</strong> <strong style="color: #1b76e8;">+91-9510-9510-19</strong></li>
                </ul>
            </div>
            
            <!-- Build Summary Section -->
            <div style="margin: 30px 0; padding: 5px 25px 10px; background: #e8e9eb; border-radius: 8px; border-left: 4px solid #10b981; font-family: Arial, sans-serif;">
                <h2 style="color: #0f2937; border-bottom: 2px solid #10b981; padding-bottom: 12px; font-size: 22px; font-weight: 700; margin-bottom: 20px; font-family: Arial, sans-serif;">Build Summary</h2>
                ${buildSummaryHTML || '<div style="text-align: center; color: #6b7280; padding: 40px; font-style: italic; font-family: Arial, sans-serif;">No components selected</div>'}
                ${totalPriceHTML}
            </div>
            
            <!-- Case and Compatibility Section -->
            ${caseCompatibilitySectionHTML}
            
            <!-- Requested image before warranty section -->
            <div style="margin: 40px 0; text-align: center;">
                <img src="https://pcbuildz.in/cdn/shop/files/Dream-PC-Buying-Process-Desktop-Banner-by-PCBuildz.webp?v=1761727890" 
                     alt="Dream PC Buying Process" 
                     crossorigin="anonymous"
                     style="width: 100%; max-height: auto; object-fit: contain; border-radius: 8px;">
            </div>
            
            <div style="margin: 30px 0; padding: 25px; background: #e8e9eb; border-radius: 8px; border-left: 4px solid #1b76e8; font-family: Arial, sans-serif;">
                <h2 style="color: #0f2937; font-size: 20px; font-weight: 700; margin-bottom: 15px; text-align: justify;">Warranty & Support: We stand behind the quality of every build!</h2>
                <ul style="margin: 15px 0; padding-left: 20px; font-family: Arial, sans-serif; text-align: justify;">
                    <li style="margin-bottom: 8px; text-align: justify;">All components come with the respective brand's manufacturer warranty <strong>(typically 3 years or more)</strong>.</li>
                    <li style="margin-bottom: 8px; text-align: justify;">Warranty claims are handled directly by the manufacturer's authorized service centers. For any assistance, PCBuildz will help facilitate warranty support.</li>
                    <li style="margin-bottom: 8px; text-align: justify;">PCBuildz provides a 3-year onsite warranty on the entire system from our side, ensuring peace of mind.</li>
                    <li style="margin-bottom: 8px; text-align: justify;">No need to worry! <strong>Our relationship extends well beyond the sale</strong>, you have a dedicated partner in PCBuildz for the full lifespan of your warranty and <strong>beyond</strong>. Basically for the rest of your life 😎</li>
                </ul>
            </div>

            <div style="margin-top: 30px; padding: 20px; background: #fff7ed; border-radius: 8px; border-left: 4px solid #f97316; font-family: Arial, sans-serif;">
                <h2 style="color: #92400e; font-size: 20px; font-weight: 700; margin-bottom: 10px; text-align: justify;">Disclaimer</h2>
                <p style="color: #78350f; line-height: 1.6; font-size: 14px; text-align: justify;">
                    This quotation is prepared exclusively for your review and budget planning. Please note that it does not constitute a final, binding offer until formally accepted and confirmed by PCBuildz.
                    Due to the dynamic nature of the PC components market, prices and stock levels are subject to fluctuation. To secure the quoted specifications and pricing, we strongly recommend confirming your order promptly.
                    While our team strives for 100% accuracy, we encourage you to consult with us directly to verify all final compatibility and specification details before placing your order. This ensures your custom PC meets your exact needs.
                </p>
            </div>

            <!-- Add the new footer image -->
            <div style="text-align: center; margin: 40px 0 20px 0;">
                <img src="https://pcbuildz.in/cdn/shop/files/Why-Choose-Us-Mobile-banner-by-PCBuildz.webp?v=1764346262" 
                     alt="Why Choose PCBuildz" 
                     crossorigin="anonymous"
                     style="width: 100%; max-height: auto; object-fit: contain; border-radius: 4px;">
            </div>

            <!-- Requested Terms & Conditions section -->
            <div style="margin: 40px 0; padding: 25px; background: #f8f9fa; border-radius: 8px; border-left: 4px solid #374151; font-family: Arial, sans-serif;">
                <h2 style="color: #0f2937; text-align: center; font-size: 24px; font-weight: 700; margin-bottom: 25px; border-bottom: 2px solid #374151; padding-bottom: 15px; text-align: justify;">Terms & Conditions of Sale</h2>
                
                <div style="margin-bottom: 25px;">
                    <h3 style="color: #1e40af; font-size: 18px; font-weight: 700; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px solid #d1d5db; text-align: justify;">Pricing & Taxes</h3>
                    <ul style="margin: 0 0 0 15px; padding-left: 10px; font-size: 14px; color: #374151; line-height: 1.6; text-align: justify;">
                        <li style="margin-bottom: 6px; text-align: justify;">All prices mentioned are inclusive of applicable GST unless explicitly stated otherwise.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Prices are subject to change without prior notice due to component availability, price fluctuations, or manufacturer revisions.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Any concessional GST (e.g., institutional rates) will apply only upon submission and verification of valid documentation.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Shipping charges may be included or charged separately depending on the quotation and delivery mode selected.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">No hidden or additional charges will be applied except clearly mentioned convenience fees, EMI charges, or special shipping requests.</li>
                    </ul>
                </div>
                
                <div style="margin-bottom: 25px;">
                    <h3 style="color: #1e40af; font-size: 18px; font-weight: 700; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px solid #d1d5db; text-align: justify;">Quotation Validity</h3>
                    <ul style="margin: 0 0 0 15px; padding-left: 10px; font-size: 14px; color: #374151; line-height: 1.6; text-align: justify;">
                        <li style="margin-bottom: 6px; text-align: justify;">Quotations are valid only until the expiry date mentioned on the document.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Prices and selected components are locked only after receiving the required advance or token payment.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Any change requested after quotation approval may result in revised pricing and delivery timelines.</li>
                    </ul>
                </div>
                
                <div style="margin-bottom: 25px;">
                    <h3 style="color: #1e40af; font-size: 18px; font-weight: 700; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px solid #d1d5db; text-align: justify;">Order Placement & Advance Payment</h3>
                    <ul style="margin: 0 0 0 15px; padding-left: 10px; font-size: 14px; color: #374151; line-height: 1.6; text-align: justify;">
                        <li style="margin-bottom: 6px; text-align: justify;">A minimum advance payment (typically 30%) is required to confirm and initiate the build process.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Token amounts may be accepted to reserve components, but the build will not begin until the minimum advance is received.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Full payment must be completed before dispatch of the system. In case of Bangalore Delivery, rest of the payment can be done on delivery.</li>
                    </ul>
                </div>
                
                <div style="margin-bottom: 25px;">
                    <h3 style="color: #1e40af; font-size: 18px; font-weight: 700; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px solid #d1d5db; text-align: justify;">Order Cancellation</h3>
                    <ul style="margin: 0 0 0 15px; padding-left: 10px; font-size: 14px; color: #374151; line-height: 1.6; text-align: justify;">
                        <li style="margin-bottom: 6px; text-align: justify;">Cancellation before build initiation may incur nominal cancellation and gateway charges.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Cancellation after the build has started will attract higher cancellation charges due to labor, testing, and component allocation.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Cancellation after the PC is fully built may incur significant deductions as per the stage of completion.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Token or advance refunds, if applicable, will be processed after deducting convenience and transaction fees.</li>
                    </ul>
                </div>
                
                <div style="margin-bottom: 25px;">
                    <h3 style="color: #1e40af; font-size: 18px; font-weight: 700; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px solid #d1d5db; text-align: justify;">Build, Testing & Dispatch</h3>
                    <ul style="margin: 0 0 0 15px; padding-left: 10px; font-size: 14px; color: #374151; line-height: 1.6; text-align: justify;">
                        <li style="margin-bottom: 6px; text-align: justify;">All systems are professionally assembled with proper cable management and component handling.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">A multi-point testing and quality-check process is performed before dispatch.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Build timelines typically range between 1-3 working days, excluding weekends and holidays.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Delays may occur due to component availability, additional testing requirements, or high-volume sales periods.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Rush builds may have limited testing due to time constraints and may carry higher risk of post-delivery issues.</li>
                    </ul>
                </div>
                
                <div style="margin-bottom: 25px;">
                    <h3 style="color: #1e40af; font-size: 18px; font-weight: 700; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px solid #d1d5db; text-align: justify;">Shipping & Delivery</h3>
                    <ul style="margin: 0 0 0 15px; padding-left: 10px; font-size: 14px; color: #374151; line-height: 1.6; text-align: justify;">
                        <li style="margin-bottom: 6px; text-align: justify;">Shipping is arranged only after full payment confirmation. Unless delivery is within Bangalore City.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Delivery timelines may vary based on location, courier partner, and shipping mode selected.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">The seller is not responsible for courier delays beyond their control.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Express or air shipping may be available at an additional cost.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Customers must ensure availability at the delivery address to avoid failed delivery or re-shipment charges.</li>
                    </ul>
                </div>
                
                <div style="margin-bottom: 25px;">
                    <h3 style="color: #1e40af; font-size: 18px; font-weight: 700; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px solid #d1d5db; text-align: justify;">Unboxing & Transit Damage</h3>
                    <ul style="margin: 0 0 0 15px; padding-left: 10px; font-size: 14px; color: #374151; line-height: 1.6; text-align: justify;">
                        <li style="margin-bottom: 6px; text-align: justify;">Customers are required to record a clear, uninterrupted unboxing video at the time of delivery.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Transit damage claims will only be accepted if supported by a valid unboxing video.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Visible damage must be reported immediately upon delivery.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Failure to provide unboxing proof may void transit damage claims.</li>
                    </ul>
                </div>
                
                <div style="margin-bottom: 25px;">
                    <h3 style="color: #1e40af; font-size: 18px; font-weight: 700; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px solid #d1d5db; text-align: justify;">DOA (Dead on Arrival) Policy</h3>
                    <ul style="margin: 0 0 0 15px; padding-left: 10px; font-size: 14px; color: #374151; line-height: 1.6; text-align: justify;">
                        <li style="margin-bottom: 6px; text-align: justify;">Any DOA issues must be reported within the specified period (typically 7 days from delivery).</li>
                        <li style="margin-bottom: 6px; text-align: justify;">After the DOA period, standard warranty procedures will apply.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Conditional DOA policies may apply for remote or extended-delivery locations.</li>
                    </ul>
                </div>
                
                <div style="margin-bottom: 25px;">
                    <h3 style="color: #1e40af; font-size: 18px; font-weight: 700; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px solid #d1d5db; text-align: justify;">Technical Support (Lifetime Free)</h3>
                    <ul style="margin: 0 0 0 15px; padding-left: 10px; font-size: 14px; color: #374151; line-height: 1.6; text-align: justify;">
                        <li style="margin-bottom: 6px; text-align: justify;">Free remote technical support is provided for a defined period during business hours.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Support may be offered via phone, email, or remote access.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Customers must schedule support sessions in advance.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Technical support is limited to hardware and software provided with the purchased system.</li>
                    </ul>
                </div>
                
                <div style="margin-bottom: 25px;">
                    <h3 style="color: #1e40af; font-size: 18px; font-weight: 700; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px solid #d1d5db; text-align: justify;">On-Site Support</h3>
                    <ul style="margin: 0 0 0 15px; padding-left: 10px; font-size: 14px; color: #374151; line-height: 1.6; text-align: justify;">
                        <li style="margin-bottom: 6px; text-align: justify;">On-site troubleshooting services may be limited by region and frequency.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Additional on-site visits beyond the included limit may be chargeable.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">On-site support may not be available in certain remote or non-serviceable areas.</li>
                    </ul>
                </div>
                
                <div style="margin-bottom: 25px;">
                    <h3 style="color: #1e40af; font-size: 18px; font-weight: 700; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px solid #d1d5db; text-align: justify;">Software & Operating System</h3>
                    <ul style="margin: 0 0 0 15px; padding-left: 10px; font-size: 14px; color: #374151; line-height: 1.6; text-align: justify;">
                        <li style="margin-bottom: 6px; text-align: justify;">Operating systems, if included, will be pre-installed and activated as mentioned.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">OS license keys may be provided separately after delivery.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">PCBuildz is not responsible for issues arising from cracked, pirated, or third-party software installations.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Software support beyond basic installation is not included unless explicitly mentioned.</li>
                    </ul>
                </div>
                
                <div style="margin-bottom: 25px;">
                    <h3 style="color: #1e40af; font-size: 18px; font-weight: 700; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px solid #d1d5db; text-align: justify;">User Modifications & Misuse</h3>
                    <ul style="margin: 0 0 0 15px; padding-left: 10px; font-size: 14px; color: #374151; line-height: 1.6; text-align: justify;">
                        <li style="margin-bottom: 6px; text-align: justify;">Warranty and technical support become void if the system is modified, overclocked, or altered without authorization.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Damage caused by improper handling, electrical issues, liquid exposure, or misuse is not covered.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">PCBuildz is not responsible for data loss under any circumstances.</li>
                    </ul>
                </div>
                
                <div style="margin-bottom: 25px;">
                    <h3 style="color: #1e40af; font-size: 18px; font-weight: 700; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px solid #d1d5db; text-align: justify;">Accessories & Inclusions</h3>
                    <ul style="margin: 0 0 0 15px; padding-left: 10px; font-size: 14px; color: #374151; line-height: 1.6; text-align: justify;">
                        <li style="margin-bottom: 6px; text-align: justify;">Accessories such as display cables, adapters, or power cords may vary by manufacturer.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Wi-Fi and Bluetooth are included only if supported by the selected motherboard or adapter.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Complimentary items, if provided, are not eligible for replacement or warranty claims.</li>
                    </ul>
                </div>
                
                <div style="margin-bottom: 25px;">
                    <h3 style="color: #1e40af; font-size: 18px; font-weight: 700; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px solid #d1d5db; text-align: justify;">Payment Failures & Penalties</h3>
                    <ul style="margin: 0 0 0 15px; padding-left: 10px; font-size: 14px; color: #374151; line-height: 1.6; text-align: justify;">
                        <li style="margin-bottom: 6px; text-align: justify;">Failed or bounced payments may attract penalties as per banking regulations.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Pending payments must be cleared within the stipulated timeframe after testing or notification.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Delayed payments may incur daily holding or storage charges.</li>
                    </ul>
                </div>
                
                <div style="margin-bottom: 25px;">
                    <h3 style="color: #1e40af; font-size: 18px; font-weight: 700; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px solid #d1d5db; text-align: justify;">Liability Limitations</h3>
                    <ul style="margin: 0 0 0 15px; padding-left: 10px; font-size: 14px; color: #374151; line-height: 1.6; text-align: justify;">
                        <li style="margin-bottom: 6px; text-align: justify;">PCBuildz's liability is strictly limited to the value of the purchased system.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">PCBuildz is not responsible for indirect losses, business downtime, or consequential damages.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Support obligations are limited to products purchased directly from PCBuildz.</li>
                    </ul>
                </div>
                
                <div style="margin-bottom: 25px;">
                    <h3 style="color: #1e40af; font-size: 18px; font-weight: 700; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px solid #d1d5db; text-align: justify;">Documentation & Media</h3>
                    <ul style="margin: 0 0 0 15px; padding-left: 10px; font-size: 14px; color: #374151; line-height: 1.6; text-align: justify;">
                        <li style="margin-bottom: 6px; text-align: justify;">Build photos, videos, and test reports may be shared for transparency.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Media files, if provided, will be available for download for a limited time only.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Customers are advised to save all shared documentation for future reference.</li>
                    </ul>
                </div>
                
                <div style="margin-bottom: 15px;">
                    <h3 style="color: #1e40af; font-size: 18px; font-weight: 700; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px solid #d1d5db; text-align: justify;">General</h3>
                    <ul style="margin: 0 0 0 15px; padding-left: 10px; font-size: 14px; color: #374151; line-height: 1.6; text-align: justify;">
                        <li style="margin-bottom: 6px; text-align: justify;">Acceptance of the quotation implies acceptance of all terms and conditions listed above.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">Terms are subject to change without prior notice.</li>
                        <li style="margin-bottom: 6px; text-align: justify;">These Terms and any disputes arising out of or related to these Terms will be governed under the law of Jurisdiction at the "Court of Arbitration" of Bengaluru, without regard to its conflict of law principles.</li>
                    </ul>
                </div>
            </div>

            <!-- Requested About Us section - styled like warranty/disclaimer -->
            <div style="margin: 40px 0; padding: 25px; background: #eef2ff; border-radius: 8px; border-left: 4px solid #4f46e5; font-family: Arial, sans-serif;">
                <h2 style="color: #0f2937; font-size: 24px; font-weight: 700; margin-bottom: 20px; text-align: center; border-bottom: 2px solid #4f46e5; padding-bottom: 15px;">About Us</h2>
                <p style="color: #374151; line-height: 1.6; font-size: 16px; margin-bottom: 25px; text-align: justify;">
                    PCBuildz is a high-performance custom PC builder focused on delivering purpose-built systems for gamers, creators, professionals, and enterprises. From high-end gaming and creative editing rigs to AI & machine learning workstations, architecture/3D systems, simulation/VR setups, and GPU-powered servers, every PC is carefully designed, assembled, and tested to match real-world workloads. With genuine components, expert craftsmanship, and a transparent build process, PCBuildz ensures reliable performance, scalability, and long-term value in every custom system we deliver.
                </p>
                <div style="text-align: center;">
                    <img src="https://pcbuildz.in/cdn/shop/files/PCBuildz-PC-Quotation-about-us-image.webp?v=1766846814" 
                         alt="PCBuildz About Us" 
                         crossorigin="anonymous"
                         style="width: 100%; max-height: auto; object-fit: contain; border-radius: 8px;">
                </div>
            </div>

            <div style="text-align: center; margin-top: 40px; padding-top: 20px; border-top: 2px solid #10b981; font-family: Arial, sans-serif;">
                <div style="font-size: 14px; color: #374151;">
                    <strong>PCBuildz</strong> — Your Trusted Custom PC Partner<br>
                    <span style="color: #6b7280;">Website:</span> www.pcbuildz.in &nbsp; | &nbsp;
                    <span style="color: #6b7280;">Email:</span> sales@pcbuildz.in
                </div>
                <div style="margin-top: 8px; font-size: 12px; color: #9ca3af;">
                    © ${new Date().getFullYear()} PCBuildz. All Rights Reserved.
                </div>
            </div>
        </div>
    `;
}

window.generatePDF = generatePDF;
